import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Features from "./components/Features";
import HowItWorks from "./components/HowItWorks";
import Pricing from "./components/Pricing";
import FAQ from "./components/FAQ";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import SeoHead from "@/components/feature/SeoHead";
import { booker } from "@/content";

/**
 * БроньСРМ. Один адрес — две темы.
 */
export default function BookerPage() {

  return (
    <>
      <SeoHead
        title={booker.seo.title}
        description={booker.seo.description}
        keywords={booker.seo.keywords}
        canonicalPath={booker.seo.canonicalPath}
      />
              <div className="min-h-screen font-sans bg-white dark:bg-[#0A0A0A]">
          <Navbar />
          <main>
            <Hero />
            <Features />
            <HowItWorks />
            <Pricing />
            <FAQ />
            <Contact />
          </main>
          <Footer />
        </div>
    </>
  );
}
